// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SlashGolf Import Modal Styles */
.slashgolf-modal {
  max-width: 1400px;
  width: 95vw;
  height: 90vh;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.3s ease-out;
  position: relative;
}

.slashgolf-modal .modal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.5rem;
  min-height: 0;
}

.import-description {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.import-description p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  font-weight: 500;
}

.import-description strong {
  font-weight: 700;
  color: #fbbf24;
}

.selection-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid #e2e8f0;
}

.select-all-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

.select-all-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.4);
}

.selection-count {
  font-weight: 700;
  color: #374151;
  font-size: 1rem;
  background: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: 1px solid #d1d5db;
}

.tournaments-table-container {
  margin: 1.5rem 0;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: auto;
  max-height: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  background: white;
}

/* Custom scrollbar styling */
.tournaments-table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.tournaments-table-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.tournaments-table-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.tournaments-table-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.tournaments-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
  background: white;
}

.tournaments-table th {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: white;
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  border-bottom: none;
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.tournaments-table th:first-child {
  border-top-left-radius: 12px;
}

.tournaments-table th:last-child {
  border-top-right-radius: 12px;
}

.tournaments-table td {
  padding: 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
  color: #64748b;
  font-size: 0.875rem;
}

.tournaments-table tr:hover {
  background: #f8fafc;
}

.tournaments-table tr:last-child td {
  border-bottom: none;
}

.tournament-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #3b82f6;
}

.tournament-name {
  min-width: 250px;
}

.tournament-name strong {
  color: #1e293b;
  display: block;
  margin-bottom: 0.25rem;
  font-weight: 700;
  font-size: 1rem;
}

.format-badge {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #dbeafe;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}

.date-info {
  font-size: 0.875rem;
  line-height: 1.5;
  color: #64748b;
}

.date-info div {
  margin-bottom: 0.25rem;
}

.date-info strong {
  color: #374151;
  font-weight: 600;
}


.import-notes {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  padding: 1.5rem;
  border-radius: 12px;
  margin: 1.5rem 0;
  border-left: 4px solid #0ea5e9;
  border: 1px solid #bae6fd;
}

.import-notes h4 {
  margin: 0 0 1rem 0;
  color: #0c4a6e;
  font-size: 1.125rem;
  font-weight: 700;
}

.import-notes ul {
  margin: 0;
  padding-left: 1.5rem;
  color: #374151;
}

.import-notes li {
  margin-bottom: 0.75rem;
  line-height: 1.5;
  font-size: 0.875rem;
}

.import-notes strong {
  color: #0c4a6e;
  font-weight: 700;
}

.import-notes > div {
  background: rgba(14, 165, 233, 0.1);
  padding: 0.75rem;
  border-radius: 6px;
  margin-top: 1rem;
  border: 1px solid #7dd3fc;
}

.loading-container {
  text-align: center;
  padding: 3rem 1.5rem;
  color: #64748b;
}

/* SlashGolf loading spinner */
.slash-golf-loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #f3f4f6;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1.5rem;
}

.error-container {
  text-align: center;
  padding: 2rem 1.5rem;
}

.error-message {
  background: #fef2f2;
  color: #dc2626;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border-left: 4px solid #dc2626;
  border: 1px solid #fecaca;
  font-size: 0.875rem;
  font-weight: 500;
}

.retry-btn {
  background: #dc2626;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s;
}

.retry-btn:hover {
  background: #b91c1c;
  transform: translateY(-1px);
}

.slash-golf-modal-actions {
  padding: 1.5rem;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  background: #f8fafc;
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.cancel-btn {
  background: #6b7280;
  color: white;
  border: none;
  padding: 0.875rem 1.75rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s;
}

.cancel-btn:hover {
  background: #4b5563;
  transform: translateY(-1px);
}

.confirm-btn {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.75rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.3);
  min-width: 140px;
  text-align: center;
}

.confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.4);
}

.confirm-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* SlashGolf Modal overlay and animations */
.slash-golf-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(4px);
}

.slash-golf-modal-header {
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
}

.modal-header h2 {
  margin: 0;
  color: #1e293b;
  font-size: 1.75rem;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.slash-golf-modal-close {
  background: none;
  border: none;
  font-size: 1.75rem;
  color: #64748b;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.2s;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  background-color: #f1f5f9;
  color: #374151;
  transform: scale(1.1);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Responsive design */
@media (max-width: 1024px) {
  .slashgolf-modal {
    width: 98vw;
    max-height: 95vh;
  }
  
  .tournaments-table th,
  .tournaments-table td {
    padding: 0.75rem 0.5rem;
  }
  
  .tournament-name {
    min-width: 200px;
  }
}

@media (max-width: 768px) {
  .slashgolf-modal {
    width: 98vw;
    max-height: 95vh;
    margin: 0.5rem;
  }
  
  .modal-header {
    padding: 1rem;
  }
  
  .modal-header h2 {
    font-size: 1.5rem;
  }
  
  .slashgolf-modal .modal-content {
    padding: 1rem;
  }
  
  .tournaments-table {
    font-size: 0.75rem;
  }
  
  .tournaments-table th,
  .tournaments-table td {
    padding: 0.5rem 0.25rem;
  }
  
  .tournament-name {
    min-width: 120px;
  }
  
  .selection-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .modal-actions {
    padding: 1rem;
    flex-direction: column;
  }
  
  .modal-actions button {
    width: 100%;
    min-height: 44px;
  }
  
  .import-description {
    padding: 1rem;
  }
  
  .import-notes {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .tournaments-table-container {
    overflow-x: auto;
    max-height: 300px;
  }
  
  .tournaments-table {
    min-width: 600px;
  }
  
  .slashgolf-modal .modal-content {
    max-height: calc(95vh - 100px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/modals/SlashGolfImportModal.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* SlashGolf Import Modal Styles */\n.slashgolf-modal {\n  max-width: 1400px;\n  width: 95vw;\n  height: 90vh;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);\n  animation: modalSlideIn 0.3s ease-out;\n  position: relative;\n}\n\n.slashgolf-modal .modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem;\n  min-height: 0;\n}\n\n.import-description {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.import-description p {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.6;\n  font-weight: 500;\n}\n\n.import-description strong {\n  font-weight: 700;\n  color: #fbbf24;\n}\n\n.selection-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #f8fafc;\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border: 1px solid #e2e8f0;\n}\n\n.select-all-btn {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n}\n\n.select-all-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.4);\n}\n\n.selection-count {\n  font-weight: 700;\n  color: #374151;\n  font-size: 1rem;\n  background: white;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n}\n\n.tournaments-table-container {\n  margin: 1.5rem 0;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: auto;\n  max-height: 400px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  background: white;\n}\n\n/* Custom scrollbar styling */\n.tournaments-table-container::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.tournaments-table-container::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.tournaments-table-container::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.tournaments-table-container::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.tournaments-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n  background: white;\n}\n\n.tournaments-table th {\n  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\n  color: white;\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: none;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.tournaments-table th:first-child {\n  border-top-left-radius: 12px;\n}\n\n.tournaments-table th:last-child {\n  border-top-right-radius: 12px;\n}\n\n.tournaments-table td {\n  padding: 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n  color: #64748b;\n  font-size: 0.875rem;\n}\n\n.tournaments-table tr:hover {\n  background: #f8fafc;\n}\n\n.tournaments-table tr:last-child td {\n  border-bottom: none;\n}\n\n.tournament-checkbox {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: #3b82f6;\n}\n\n.tournament-name {\n  min-width: 250px;\n}\n\n.tournament-name strong {\n  color: #1e293b;\n  display: block;\n  margin-bottom: 0.25rem;\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.format-badge {\n  display: inline-block;\n  padding: 0.375rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  background: #dbeafe;\n  color: #1e40af;\n  border: 1px solid #bfdbfe;\n}\n\n.date-info {\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.date-info div {\n  margin-bottom: 0.25rem;\n}\n\n.date-info strong {\n  color: #374151;\n  font-weight: 600;\n}\n\n\n.import-notes {\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  padding: 1.5rem;\n  border-radius: 12px;\n  margin: 1.5rem 0;\n  border-left: 4px solid #0ea5e9;\n  border: 1px solid #bae6fd;\n}\n\n.import-notes h4 {\n  margin: 0 0 1rem 0;\n  color: #0c4a6e;\n  font-size: 1.125rem;\n  font-weight: 700;\n}\n\n.import-notes ul {\n  margin: 0;\n  padding-left: 1.5rem;\n  color: #374151;\n}\n\n.import-notes li {\n  margin-bottom: 0.75rem;\n  line-height: 1.5;\n  font-size: 0.875rem;\n}\n\n.import-notes strong {\n  color: #0c4a6e;\n  font-weight: 700;\n}\n\n.import-notes > div {\n  background: rgba(14, 165, 233, 0.1);\n  padding: 0.75rem;\n  border-radius: 6px;\n  margin-top: 1rem;\n  border: 1px solid #7dd3fc;\n}\n\n.loading-container {\n  text-align: center;\n  padding: 3rem 1.5rem;\n  color: #64748b;\n}\n\n/* SlashGolf loading spinner */\n.slash-golf-loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #f3f4f6;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1.5rem;\n}\n\n.error-container {\n  text-align: center;\n  padding: 2rem 1.5rem;\n}\n\n.error-message {\n  background: #fef2f2;\n  color: #dc2626;\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border-left: 4px solid #dc2626;\n  border: 1px solid #fecaca;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.retry-btn {\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.retry-btn:hover {\n  background: #b91c1c;\n  transform: translateY(-1px);\n}\n\n.slash-golf-modal-actions {\n  padding: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  background: #f8fafc;\n  flex-shrink: 0;\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n}\n\n.cancel-btn {\n  background: #6b7280;\n  color: white;\n  border: none;\n  padding: 0.875rem 1.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.cancel-btn:hover {\n  background: #4b5563;\n  transform: translateY(-1px);\n}\n\n.confirm-btn {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 700;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.3);\n  min-width: 140px;\n  text-align: center;\n}\n\n.confirm-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.4);\n}\n\n.confirm-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* SlashGolf Modal overlay and animations */\n.slash-golf-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(4px);\n}\n\n.slash-golf-modal-header {\n  padding: 1.5rem 1.5rem 1rem;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: white;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #1e293b;\n  font-size: 1.75rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.slash-golf-modal-close {\n  background: none;\n  border: none;\n  font-size: 1.75rem;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 8px;\n  transition: all 0.2s;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close:hover {\n  background-color: #f1f5f9;\n  color: #374151;\n  transform: scale(1.1);\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-30px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 1024px) {\n  .slashgolf-modal {\n    width: 98vw;\n    max-height: 95vh;\n  }\n  \n  .tournaments-table th,\n  .tournaments-table td {\n    padding: 0.75rem 0.5rem;\n  }\n  \n  .tournament-name {\n    min-width: 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .slashgolf-modal {\n    width: 98vw;\n    max-height: 95vh;\n    margin: 0.5rem;\n  }\n  \n  .modal-header {\n    padding: 1rem;\n  }\n  \n  .modal-header h2 {\n    font-size: 1.5rem;\n  }\n  \n  .slashgolf-modal .modal-content {\n    padding: 1rem;\n  }\n  \n  .tournaments-table {\n    font-size: 0.75rem;\n  }\n  \n  .tournaments-table th,\n  .tournaments-table td {\n    padding: 0.5rem 0.25rem;\n  }\n  \n  .tournament-name {\n    min-width: 120px;\n  }\n  \n  .selection-controls {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n  \n  .modal-actions {\n    padding: 1rem;\n    flex-direction: column;\n  }\n  \n  .modal-actions button {\n    width: 100%;\n    min-height: 44px;\n  }\n  \n  .import-description {\n    padding: 1rem;\n  }\n  \n  .import-notes {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .tournaments-table-container {\n    overflow-x: auto;\n    max-height: 300px;\n  }\n  \n  .tournaments-table {\n    min-width: 600px;\n  }\n  \n  .slashgolf-modal .modal-content {\n    max-height: calc(95vh - 100px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
